import { SaleFormInput } from '@src/core/buyerApiClient';
import { resolveFormInputErrorMessage } from '@src/domains/orders';

export type FormInputFieldError = {
  path: string;
  message: string;
};

/**
 * Turns the `{ hash: messages[] }` map the store holds after a 422 into react-hook-form
 * field errors, restricted to the inputs this form actually renders.
 */
export const mapFormInputErrorsToFields = (
  errors: Record<string, string[]>,
  inputs: SaleFormInput[],
): FormInputFieldError[] =>
  inputs.reduce<FormInputFieldError[]>((acc, input) => {
    const messages = errors[input.hash];

    if (!messages?.length) {
      return acc;
    }

    const message = messages
      .map((raw) => resolveFormInputErrorMessage(raw, input.hash, input.formInput.name))
      .join(', ');

    return [...acc, { path: input.hash, message }];
  }, []);
